import type { BriefKeywordAlert } from '../../hooks/useCompetitiveData'

interface KeywordAlertPanelProps {
  alerts: BriefKeywordAlert[]
}

function splitIntruderName(value: string): { product: string; brand: string | null } {
  const raw = value.trim()
  const byIndex = raw.toLowerCase().lastIndexOf(' by ')
  if (byIndex <= 0) {
    return { product: raw, brand: null }
  }
  return {
    product: raw.slice(0, byIndex).trim(),
    brand: raw.slice(byIndex + 4).trim() || null,
  }
}

export default function KeywordAlertPanel({ alerts }: KeywordAlertPanelProps) {
  if (alerts.length === 0) {
    return null
  }

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4">
      <div className="space-y-3">
        {alerts.map((alert) => {
          const intruder = splitIntruderName(alert.intruder_name)

          return (
            <article
              key={`${alert.keyword}-${alert.intruder_name}-${alert.intruder_asin ?? 'n-a'}`}
              className="rounded-lg border border-slate-200 border-l-4 border-l-amber-400 bg-white p-4"
            >
              <dl className="space-y-2 text-sm">
                <div>
                  <dt className="competitive-support-label">Keyword</dt>
                  <dd className="competitive-body-text-strong">{alert.keyword}</dd>
                </div>

                <div>
                  <dt className="competitive-support-label">Threat</dt>
                  <dd className="competitive-body-text">
                    A competitor product is capturing <span className="font-semibold">{alert.competitor_share.toFixed(1)}%</span>{' '}
                    of clicks on this search.
                  </dd>
                </div>

                <div>
                  <dt className="competitive-support-label">Intruder</dt>
                  <dd className="competitive-body-text">
                    <span className="font-semibold">{intruder.product || alert.intruder_name}</span>
                    {intruder.brand ? ` by ${intruder.brand}` : ''}
                    {alert.intruder_asin ? (
                      <span className="text-slate-600"> (ASIN: {alert.intruder_asin})</span>
                    ) : null}
                  </dd>
                </div>

                <div>
                  <dt className="competitive-support-label">Action</dt>
                  <dd className="competitive-body-text">{alert.recommended_action}</dd>
                </div>
              </dl>
            </article>
          )
        })}
      </div>
    </section>
  )
}
